import createManagementPageLifecycle from "@shared/createManagementPageLifecycle.cjs";

export default createManagementPageLifecycle({
  navbar: "5",
  navbarHook: "mounted",
  loadMethods: ["loadInfo"],
});
